import { defineMessages } from 'react-intl';

export default defineMessages({ 
    privacyDisclosureTextPart1: {
        id: 'privacyDisclosure.text.part1',
        defaultMessage: 'For more information about what we collect and how we use it, please view our '
    },
    privacyDisclosureTextPart2: {
        id: 'privacyDisclosure.text.part2',
        defaultMessage: '.'
    }    
});
